<form #form="ngForm" (ngSubmit)="save(form)" class="workgroup-position-rostertype-form">
  <p-message severity="error" text="{{errorMessage}}" *ngIf="errorMessage"></p-message>
  
  <div class="p-fluid p-grid p-mt-0">
    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <p-multiSelect [options]="workGroups" 
                        class="p-inputtext-sm" 
                        name="workGroup"
                        appendTo="body"
                        [showHeader]="true"
                        [filter]="true"
                        [showToggleAll]="true"
                        inputId="workGroup" 
                        optionLabel="name"
                        dataKey="id"
                        [maxSelectedLabels]="1"                        
                        [(ngModel)]="selectedWorkGroups">
        </p-multiSelect>
        <label for="workGroup" class="bold-field blue-field">Work Group</label>
      </span>
    </div>

    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <p-multiSelect [options]="positions" 
                        class="p-inputtext-sm" 
                        name="positions"
                        appendTo="body"
                        [showHeader]="true"
                        [filter]="true"
                        [showToggleAll]="true"
                        inputId="positions" 
                        optionLabel="title"
                        dataKey="id"
                        [maxSelectedLabels]="1"                        
                        [(ngModel)]="selectedPositions">
        </p-multiSelect>
        <label for="position" class="bold-field blue-field">Position</label>
      </span>
    </div>

    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <p-dropdown #positionDD [options]="rosterTypes" 
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    inputId="rosterType" 
                    name="rosterType"
                    optionLabel="title"
                    dataKey="id"
                    [autoDisplayFirst]="false"
                    [(ngModel)]="selectedRosterType"></p-dropdown>
        <label for="rosterType" class="bold-field blue-field">Roster Type</label>
      </span>
    </div>
  </div>

  <div class="modal-footer">
    <button pButton pRipple label="Save" class="p-button p-button-raised" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Cancel" class="p-button p-button-raised p-button-outlined" icon="pi pi-times" type="button" (click)="cancel()"></button>
  </div>
</form>